
/**
 * === Desktop : Search Bar
 */

window.addEventListener("DOMContentLoaded", (event) => {

  // Search Bar position

  var searchOpen = document.querySelectorAll('.navlink[data-popdown-toggle="search-popdown"]');

  if (searchOpen.length > 0) {
    searchOpen.forEach(function (searchOpenBtn) {
      searchOpenBtn.addEventListener('click', function (e) {

        var announcementBar = document.querySelector('.announcement__wrapper');
        var announcementBarHeight = 0;
        if (announcementBar !== null && announcementBar !== undefined) {
          announcementBarHeight = announcementBar.offsetHeight;
        }

        var header = document.querySelector('.theme__header');
        var headerHeight = 0;
        if (header !== null && header !== undefined) {
          headerHeight = header.offsetHeight;
        }

        var scrollTop = window.scrollY;
        var searchMarginTop = headerHeight;
        if (scrollTop < announcementBarHeight) {
          searchMarginTop = headerHeight + (announcementBarHeight - scrollTop);
        }

        var searchOuter = document.querySelector('#search-popdown');
        if (searchOuter !== null && searchOuter !== undefined) {
          searchOuter.style.marginTop = searchMarginTop+'px';
        }

      });
    });
  }

});


/**
 * === Desktop : Product page - size selector
 */

 window.addEventListener("DOMContentLoaded", (event) => {

   var handleize = function (str) {
        str = str.toLowerCase();

        var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

        // For the old browsers
        for (var i = 0; i < toReplace.length; ++i) {
            str = str.replace(toReplace[i], "");
        }

        str = str.replace(/\W+/g, "-");

        if (str.charAt(str.length - 1) == "-") {
            str = str.replace(/-+\z/, "");
        }

        if (str.charAt(0) == "-") {
            str = str.replace(/\A-+/, "");
        }

        return str
    };

  var sizeOptionsDesk = document.querySelectorAll('.selector-wrapper.size-options.only-desktop [data-single-option-selector]');
  var sizeOptionsMob = document.querySelectorAll('.selector-wrapper.size-options.only-mobile [data-popout-option]');

    if (sizeOptionsDesk.length > 0 && sizeOptionsMob.length > 0) {
    sizeOptionsDesk.forEach(function (sizeOptionDesk) {
      sizeOptionDesk.addEventListener('click', function (e) {

        var sizeOptionValueDesk = sizeOptionDesk.value;

        sizeOptionsMob.forEach(function (sizeOptionMob) {
          var sizeOptionValueMob = sizeOptionMob.getAttribute('data-value');
          if (sizeOptionValueDesk == sizeOptionValueMob) {
            sizeOptionMob.click();
          }
        });
      });
    });
  }

  // Sister variant barré
  var sizeOptions = document.querySelectorAll('.selector-wrapper.size-options [data-single-option-selector]')
  if(sizeOptions.length > 0){
	sizeOptions.forEach(function(sizeOption){
      	sizeOption.addEventListener('click', function (e) {
			var sizeOptionValue = sizeOption.value;
          	var handleizeSizeOptionValue = handleize(sizeOptionValue)
      		console.log('Size option ' + handleize(sizeOptionValue));

          	var sisterSizes = document.querySelectorAll('[data-sister-product-handle]');
            sisterSizes.forEach(function(e){
				console.log('Element ' + e.getAttribute('data-sister-variant-size-' + handleizeSizeOptionValue));
              	e.classList.remove('variant-disabled');
                if(!e.getAttribute('data-sister-variant-size-' + handleizeSizeOptionValue)){
					e.classList.add('variant-disabled');
                }
            });

    	});
  });
  }


});


/**
 * === Mobile : Product page - size selector scroll on toggle
 */

 window.addEventListener("DOMContentLoaded", (event) => {

  var windowWidth = window.innerWidth;

  if (windowWidth <= 900) {

    var sizeToggleBtn = document.querySelectorAll('.template-product .select-popout__toggle');
    if (sizeToggleBtn.length > 0 && sizeToggleBtn.length > 0) {
      sizeToggleBtn.forEach(function (button) {
        button.addEventListener('click', function (e) {

          const y = button.getBoundingClientRect().top - 120;

          window.scrollTo({top: y, behavior: 'smooth'});

        });
      });
    }

  }

});


/**
 * === Desktop : Product quick view
 */

var onVariantChange = () => {
  var optionsInput = document.querySelectorAll('[data-quickview] .product__selectors input');
  var inputVariantId = document.querySelector('[data-quickview] .product-form input[name="id"]');

  // Init variant id
  if (optionsInput.length > 0
    && inputVariantId !== null
    && inputVariantId !== undefined) {
      optionsInput.forEach(function (option) {
        if (option.checked) {
          var selectedVariantId = option.getAttribute('data-option-variant-id');
          if (selectedVariantId !== null && selectedVariantId !== undefined) {
            inputVariantId.value = selectedVariantId;
          }
        }
      });
  }

  // On variant change
  if (optionsInput.length > 0
    && inputVariantId !== null
    && inputVariantId !== undefined) {
      optionsInput.forEach(function (option) {
        option.addEventListener('change', function (e) {
          var selectedVariantId = option.getAttribute('data-option-variant-id');
          if (selectedVariantId !== null && selectedVariantId !== undefined) {
            inputVariantId.value = selectedVariantId;

            // Update buttons
            const optionAvailable = option.getAttribute('data-option-available');
            const showButton = document.getElementById('product-show-button');
            if (showButton !== null && showButton !== undefined) {
              if (optionAvailable === 'false') {
                showButton.classList.add('active');
              } else {
                showButton.classList.remove('active');
              }
            }
            const addButton = document.querySelector('[data-quickview] .product-form .product__submit__add');
            if (addButton !== null && addButton !== undefined) {
              if (optionAvailable === 'true') {
                addButton.classList.add('active');
              } else {
                addButton.classList.remove('active');
              }
            }
          }
        });
      });
  }

  // VAD - Init variant id
  var AddToCartVAD = document.querySelector('[data-quickview] .product-form .product__submit__add');
  if (optionsInput.length > 0
    && AddToCartVAD !== null
    && AddToCartVAD !== undefined) {
      optionsInput.forEach(function (option) {
        if (option.checked) {
          var selectedVariantId = option.getAttribute('data-option-variant-id');
          if (selectedVariantId !== null && selectedVariantId !== undefined) {
            AddToCartVAD.setAttribute("data-vad-variant-id", selectedVariantId);
          }
        }
      });
  }

  // VAD - on variant change
  var AddToCartVAD = document.querySelector('[data-quickview] .product-form .product__submit__add');
  if (optionsInput.length > 0
    && AddToCartVAD !== null
    && AddToCartVAD !== undefined) {
      optionsInput.forEach(function (option) {
        option.addEventListener('change', function (e) {
          var selectedVariantId = option.getAttribute('data-option-variant-id');
          if (selectedVariantId !== null && selectedVariantId !== undefined) {
            AddToCartVAD.setAttribute("data-vad-variant-id", selectedVariantId);
          }
        });
      });
  }

  //=== Product Color Selector
    var colorSelector = document.querySelector('[data-quickview] .product-form [data-product-color-selector]');
    if (colorSelector !== null && colorSelector !== undefined) {
      colorSelector.addEventListener('click', function (e) {
        colorSelector.classList.toggle('is-open');
      });
    }
}

window.addEventListener("DOMContentLoaded", (event) => {

  const windowWidth = window.innerWidth;

  if (windowWidth > 768) {
    var quickview = document.querySelector('[data-quickview]');
    var quickviewInner = document.querySelector('[data-quickview-inner]');
    var productsQuickviewContentWrapper = document.querySelectorAll('[quickview-content-wrapper]');

    if (productsQuickviewContentWrapper.length > 0
      && quickview !== null
      && quickview !== undefined
      && quickviewInner !== null
      && quickviewInner !== undefined) {

      var quickviewBtnOpen = document.querySelectorAll('[data-quickview-open]');
      var quickviewBtnClose = document.querySelectorAll('[data-quickview-close]');

      // === On open
      if (quickviewBtnOpen.length > 0) {
        quickviewBtnOpen.forEach(function (button) {
          button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var item = button.closest('.product-item');
            if (item !== null && item !== undefined) {
              var thisQuickviewContentWrapper = item.querySelector('[quickview-content-wrapper]');
              if (thisQuickviewContentWrapper !== null && thisQuickviewContentWrapper !== undefined) {

                // If size clicked : select good size
                if (button.getAttribute('data-quickview-option-size') !== null && button.getAttribute('data-quickview-option-size') !== undefined) {
                  var sizeOptions = item.querySelectorAll('[quickview-content-wrapper] .size-options input');
                  if (sizeOptions.length > 0) {
                    sizeOptions.forEach(sizeOption => {
                      if (sizeOption.value == button.getAttribute('data-quickview-option-size')) {
                        sizeOption.checked = true;
                      }
                    });
                  }
                }

                // Clone and insert
                var clonethisQuickviewContentWrapper = thisQuickviewContentWrapper.cloneNode(true);
                quickviewInner.appendChild(clonethisQuickviewContentWrapper);

                // add icons-txt
                var iconsTxt = document.querySelector('[data-quickview-icons-txt]');
                var iconsTxtWrapper = document.querySelector('[data-quickview-wrap-icons-txt]');
                if (iconsTxt !== null && iconsTxt !== undefined && iconsTxtWrapper !== null && iconsTxtWrapper !== undefined) {
                  var cloneIconsTxt = iconsTxt.cloneNode(true);
                  iconsTxtWrapper.appendChild(cloneIconsTxt);
                }

                quickview.classList.add('active');

                onVariantChange();
              }
            }
          });
        });
      }

      // === On close
      if (quickviewBtnClose.length > 0) {
        quickviewBtnClose.forEach(function (button) {
          button.addEventListener('click', function (e) {
            var quickviewContentWrapper = quickview.querySelector('[quickview-content-wrapper]');
            if (quickviewContentWrapper !== null && quickviewContentWrapper !== undefined) {
              quickviewContentWrapper.remove();
            }
            quickview.classList.remove('active');
          });
        });
      }

    }
  }

});


/**
 * === VAD - Product page Add To Cart
 */

window.addEventListener("DOMContentLoaded", (event) => {

  var optionsInput = document.querySelectorAll('.template-product .product__selectors input');
  var AddToCartVAD = document.querySelector('.template-product .product-form .product__submit__add');

  if (optionsInput.length > 0
    && AddToCartVAD !== null
    && AddToCartVAD !== undefined) {
      optionsInput.forEach(function (option) {
        option.addEventListener('change', function (e) {
          let selectedVariantId = option.getAttribute('data-option-variant-id');
          if (e.target.hasAttribute("data-id-variante-custo")) {
            var sizeOptionsVadDesk = document.querySelectorAll('.selector-wrapper.size-options.only-desktop [data-single-option-selector]');
            var sizeOptionValueVadMob = e.target.value;

            if (sizeOptionsVadDesk.length > 0) {
              for (const item of sizeOptionsVadDesk) {
                var sizeOptionValueDesk = item.value;
                if (sizeOptionValueDesk === sizeOptionValueVadMob) {
                  selectedVariantId = item.getAttribute('data-option-variant-id');
                  break
                }
              }
            }
          }

          if (selectedVariantId !== null && selectedVariantId !== undefined) {
            AddToCartVAD.setAttribute("data-vad-variant-id", selectedVariantId);

            // Update BIS button
            const optionAvailable = option.getAttribute('data-option-available');
            const bisButton = document.getElementById('BIS_trigger');
            if (bisButton !== null && bisButton !== undefined) {
              bisButton.setAttribute('data-variant-id', selectedVariantId);
              if (optionAvailable === 'false') {
                bisButton.classList.add('active');
              } else {
                bisButton.classList.remove('active');
              }
            }
          }
        });
      });
  }

});


const filterButton = document.querySelector('[data-group-tags-enabled]');
if(filterButton){
  filterButton.onclick = function(){
    setTimeout(function(){
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    }, 1000);
  }
}
